import { render } from "./HelloWorld.vue?vue&type=template&id=657c236e&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=657c236e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Bartosz Krych\\Documents\\master-thesis-forms\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-657c236e"]])

export default __exports__